import { render } from "./Dev.vue?vue&type=template&id=2d42ea9b&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=js"
export * from "./Dev.vue?vue&type=script&lang=js"

import "./Dev.vue?vue&type=style&index=0&id=2d42ea9b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d42ea9b"]])

export default __exports__